import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import brandModels from '../brandModels';
import brandBodyTypes from '../brandBodyTypes';
import { useTheme } from '../theme';
import { apiUrl } from '../api';
import { useLanguage } from '../App';

function BuyBack() {
  const { carId } = useParams();
  const navigate = useNavigate();
  const { tokens } = useTheme();
  const { language } = useLanguage();
  const [car, setCar] = useState(null);
  const [form, setForm] = useState({
    phone: '',
    brand: 'BMW',
    model: (brandModels['BMW'] || ['Other'])[0] || 'Other',
    year: '',
    price: '',
    km: '',
    fuel: '',
    gearbox: '',
    type: (brandBodyTypes['BMW'] || ['Other'])[0] || 'Other',
    capacity: '',
    power: '',
    description: ''
  });
  const [brandList] = useState([
    'Abarth','Acura','Alfa Romeo','Aston Martin','Audi','Bentley','BMW','Bugatti','Buick','Cadillac','Chevrolet','Chrysler','Citroën','Cupra','Dacia','Daewoo','Daihatsu','Dodge','DS','Ferrari','Fiat','Ford','Genesis','GMC','Honda','Hummer','Hyundai','Infiniti','Isuzu','Jaguar','Jeep','Kia','Lada','Lamborghini','Lancia','Land Rover','Lexus','Lincoln','Lotus','Maserati','Mazda','McLaren','Mercedes','MG','Mini','Mitsubishi','Nissan','Opel','Peugeot','Polestar','Pontiac','Porsche','RAM','Renault','Rolls-Royce','Rover','Saab','Seat','Skoda','Smart','SsangYong','Subaru','Suzuki','Tesla','Toyota','Volkswagen','Volvo','Other'
  ]);
  const [modelList, setModelList] = useState(brandModels['BMW'] || ['Other']);
  const [typeList, setTypeList] = useState(brandBodyTypes['BMW'] || ['Other']);
  const [images, setImages] = useState([]);
  const [talon, setTalon] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const t = {
    en: {
      pageTitle: 'Trade-In / Appraisal',
      wantBuyback: 'Want to trade-in your car?',
      chooseCar: 'To continue, first choose a car from our stock.',
      chooseNow: 'Choose now from stock',
      buybackFor: 'Trade-in for:',
      phone: 'Phone (required)',
      phonePlaceholder: '07xx xxx xxx',
      brand: 'Brand',
      model: 'Model',
      type: 'Type',
      year: 'Year',
      chooseYear: 'Choose year',
      desiredPrice: 'Desired price for your car (EUR)',
      pricePlaceholder: 'e.g: 7 500',
      km: 'Km',
      fuel: 'Fuel',
      chooseFuel: 'Choose fuel',
      petrol: 'Petrol',
      diesel: 'Diesel',
      hybrid: 'Hybrid',
      electric: 'Electric',
      lpg: 'LPG',
      other: 'Other',
      gearbox: 'Gearbox',
      chooseGearbox: 'Choose gearbox',
      manual: 'Manual',
      automatic: 'Automatic',
      capacity: 'Capacity',
      capacityPlaceholder: 'cc',
      power: 'Power',
      powerPlaceholder: 'HP',
      description: 'Description',
      photos: 'Car photos (max 10)',
      clickUpload: 'Click to upload photos',
      dragDrop: 'Or drag photos here',
      noPhotos: 'No photos selected',
      photoSelected: 'photo selected',
      photosSelected: 'photos selected',
      uploadTalon: 'Upload registration photo (optional)',
      detailedEval: 'For more detailed appraisal and faster response!',
      selectTalon: 'Select registration photo',
      submitRequest: 'Submit request',
      requestSent: 'Request submitted',
      weWillContact: 'We will contact you soon.',
      submitError: 'Submission error'
    },
    ro: {
      pageTitle: 'Buy-back / Evaluare',
      wantBuyback: 'Dorești buy‑back la mașina ta?',
      chooseCar: 'Pentru a continua, alege mai întâi o mașină din stocul nostru.',
      chooseNow: 'Alege acum din stoc',
      buybackFor: 'Buy-back pentru:',
      phone: 'Telefon (obligatoriu)',
      phonePlaceholder: '07xx xxx xxx',
      brand: 'Marcă',
      model: 'Model',
      type: 'Tip',
      year: 'An',
      chooseYear: 'Alege anul',
      desiredPrice: 'Preț dorit pe mașina ta (EUR)',
      pricePlaceholder: 'ex: 7 500',
      km: 'Km',
      fuel: 'Combustibil',
      chooseFuel: 'Alege combustibil',
      petrol: 'Benzina',
      diesel: 'Motorina',
      hybrid: 'Hybrid',
      electric: 'Electric',
      lpg: 'GPL',
      other: 'Altul',
      gearbox: 'Cutie',
      chooseGearbox: 'Alege cutie viteze',
      manual: 'Manuala',
      automatic: 'Automata',
      capacity: 'Capacitate',
      capacityPlaceholder: 'cc',
      power: 'Putere',
      powerPlaceholder: 'CP',
      description: 'Descriere',
      photos: 'Fotografii mașină (max 10)',
      clickUpload: 'Apasă pentru a încărca fotografii',
      dragDrop: 'Sau trage fotografiile aici',
      noPhotos: 'Nicio fotografie selectată',
      photoSelected: 'fotografie selectată',
      photosSelected: 'fotografii selectate',
      uploadTalon: 'Încarcă poza talon (opțional)',
      detailedEval: 'Pentru evaluare mai detaliată și răspuns mai rapid!',
      selectTalon: 'Selectează fotografia talonului',
      submitRequest: 'Trimite cererea',
      requestSent: 'Cererea a fost trimisă',
      weWillContact: 'Vă vom contacta în curând.',
      submitError: 'Eroare la trimitere'
    }
  };
  const tr = t[language] || t.ro;

  // Scroll to top when page mounts so we start at the beginning
  useEffect(() => {
    try {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
      // Fallback for older browsers
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    } catch (_) {}
  }, []);

  useEffect(() => {
    // încărcăm sumarul mașinii țintă doar dacă există carId
    if (!carId) { setCar(null); return; }
    fetch(apiUrl(`/api/cars/${carId}`))
      .then(r => r.json())
      .then(setCar)
      .catch(() => {});
  }, [carId]);

  function onChange(e) {
    const { name, value } = e.target;
    if (name === 'brand') {
      const ms = brandModels[value] || ['Other'];
      const ts = brandBodyTypes[value] || ['Other'];
      setModelList(ms);
      setTypeList(ts);
      setForm(prev => ({ ...prev, brand: value, model: ms[0] || 'Other', type: ts[0] || 'Other' }));
      return;
    }
    setForm(prev => ({ ...prev, [name]: value }));
  }

  function onFile(e) {
    const files = Array.from(e.target.files || []);
    setImages(files.slice(0, 10));
  }
  function onTalonFile(e) {
    const f = (e.target.files && e.target.files[0]) || null;
    setTalon(f);
  }

  async function onSubmit(e) {
    e.preventDefault();
    setSubmitting(true);
    setError('');
    setSuccess('');
    try {
      const data = new FormData();
      if (carId) data.append('targetCar', carId);
      data.append('phone', form.phone);
      ['brand','model','year','price','km','fuel','gearbox','type','capacity','power','description'].forEach(k => {
        if (form[k]) data.append(k, form[k]);
      });
      images.forEach(f => data.append('images', f));
      if (talon) data.append('talon', talon);

      const resp = await fetch(apiUrl('/api/buyback'), { method: 'POST', body: data });
      const payload = await resp.json().catch(() => ({}));
      if (!resp.ok) throw new Error(payload?.error || payload?.detail || 'Trimiterea a eșuat');

  const when = new Date();
  const label = when.toLocaleString(language === 'en' ? 'en-US' : 'ro-RO', { year: 'numeric', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' });
  setSuccess(`${tr.requestSent} (${label}). ${tr.weWillContact}`);
      setForm({
        phone: '',
        brand: 'BMW',
        model: (brandModels['BMW'] || ['Other'])[0] || 'Other',
        year: '', price: '', km: '', fuel: '', gearbox: '',
        type: (brandBodyTypes['BMW'] || ['Other'])[0] || 'Other',
        capacity: '', power: '', description: ''
      });
      setModelList(brandModels['BMW'] || ['Other']);
      setTypeList(brandBodyTypes['BMW'] || ['Other']);
      setImages([]);
      setTalon(null);
      setTimeout(() => navigate(carId ? `/car/${carId}` : '/'), 1200);
    } catch (err) {
      setError(err.message || tr.submitError);
    } finally {
      setSubmitting(false);
    }
  }

  // Mobile-specific styles for select dropdowns
  const selectStyle = {
    padding: 12,
    borderRadius: 8,
    border: `1px solid ${tokens.mutedBorder}`,
    background: tokens.panel,
    color: tokens.text,
    minHeight: 48,
    fontSize: 16, // prevents zoom on iOS
    WebkitAppearance: 'none',
    MozAppearance: 'none',
    appearance: 'none',
    backgroundImage: `url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e")`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'right 10px center',
    backgroundSize: '20px',
    paddingRight: 36,
    width: '100%',
    boxSizing: 'border-box'
  };

  const inputStyle = {
    padding: 12,
    borderRadius: 8,
    border: `1px solid ${tokens.mutedBorder}`,
    background: tokens.panel,
    color: tokens.text,
    minHeight: 48,
    fontSize: 16, // prevents zoom on iOS
    width: '100%',
    boxSizing: 'border-box'
  };

  return (
    <div style={{ maxWidth: 960, margin: '20px auto', padding: 16 }}>
      <h2 style={{ marginBottom: 8 }}>{tr.pageTitle}</h2>
      {!carId && (
        <div style={{ marginBottom: 16, padding: 16, border: `1px solid ${tokens.border}`, borderRadius: 10, background: tokens.panel }}>
          <div style={{ fontWeight: 800, fontSize: 18, marginBottom: 6 }}>
            {tr.wantBuyback}
          </div>
          <div style={{ color: tokens.textMuted, marginBottom: 10 }}>
            {tr.chooseCar}
          </div>
          <Link to="/" style={{ display: 'inline-block', padding: '10px 14px', background: tokens.accent, color: tokens.inverse, borderRadius: 8, fontWeight: 800, textDecoration: 'none' }}>
            {tr.chooseNow}
          </Link>
        </div>
      )}
      {car && (
        <div style={{ marginBottom: 16, padding: 12, border: `1px solid ${tokens.border}`, borderRadius: 8, background: tokens.surface }}>
          <div style={{ fontSize: 14, color: tokens.textMuted, marginBottom: 4 }}>{tr.buybackFor}</div>
          <div style={{ fontWeight: 700, marginBottom: 4 }}>{car.title || `${car.brand || ''} ${car.model || ''}`}</div>
          {car.price && <div style={{ color: tokens.accent }}>{car.price} €</div>}
        </div>
      )}
      <form onSubmit={onSubmit} style={{ display: 'grid', gap: 12 }}>
        <label style={{ display: 'grid', gap: 6 }}>
          <span>{tr.phone}</span>
          <input required name="phone" value={form.phone} onChange={onChange} placeholder={tr.phonePlaceholder} style={inputStyle} />
        </label>
        <div style={{ display: 'grid', gap: 12, gridTemplateColumns: 'repeat(auto-fit, minmax(200px,1fr))' }}>
          <label style={{ display: 'grid', gap: 6 }}>
            <span>{tr.brand}</span>
            <select name="brand" value={form.brand} onChange={onChange} style={selectStyle}>
              {brandList.map(b => <option key={b} value={b}>{b}</option>)}
            </select>
          </label>
          <label style={{ display: 'grid', gap: 6 }}>
            <span>{tr.model}</span>
            <select name="model" value={form.model} onChange={onChange} style={selectStyle}>
              {modelList.map(m => <option key={m} value={m}>{m}</option>)}
            </select>
          </label>
          <label style={{ display: 'grid', gap: 6 }}>
            <span>{tr.type}</span>
            <select name="type" value={form.type} onChange={onChange} style={selectStyle}>
              {typeList.map(t => <option key={t} value={t}>{t}</option>)}
            </select>
          </label>
          <label style={{ display: 'grid', gap: 6 }}>
            <span>{tr.year}</span>
            <select name="year" value={form.year} onChange={onChange} style={selectStyle}>
              <option value="">{tr.chooseYear}</option>
              {Array.from({ length: 40 }, (_, i) => new Date().getFullYear() - i).map(y => (
                <option key={y} value={y}>{y}</option>
              ))}
            </select>
          </label>
          <label style={{ display: 'grid', gap: 6 }}>
            <span>{tr.desiredPrice}</span>
            <input name="price" value={form.price} onChange={onChange} placeholder={tr.pricePlaceholder} style={inputStyle} />
          </label>
          <label style={{ display: 'grid', gap: 6 }}>
            <span>{tr.km}</span>
            <input name="km" value={form.km} onChange={onChange} placeholder={tr.km} style={inputStyle} />
          </label>
          <label style={{ display: 'grid', gap: 6 }}>
            <span>{tr.fuel}</span>
            <select name="fuel" value={form.fuel} onChange={onChange} style={selectStyle}>
              <option value="">{tr.chooseFuel}</option>
              <option value="Benzina">{tr.petrol}</option>
              <option value="Motorina">{tr.diesel}</option>
              <option value="Hybrid">{tr.hybrid}</option>
              <option value="Electric">{tr.electric}</option>
              <option value="GPL">{tr.lpg}</option>
              <option value="Altul">{tr.other}</option>
            </select>
          </label>
          <label style={{ display: 'grid', gap: 6 }}>
            <span>{tr.gearbox}</span>
            <select name="gearbox" value={form.gearbox} onChange={onChange} style={selectStyle}>
              <option value="">{tr.chooseGearbox}</option>
              <option value="Manuala">{tr.manual}</option>
              <option value="Automata">{tr.automatic}</option>
              <option value="CVT">CVT</option>
              <option value="DSG">DSG</option>
              <option value="Tiptronic">Tiptronic</option>
              <option value="Altul">{tr.other}</option>
            </select>
          </label>
          <label style={{ display: 'grid', gap: 6 }}>
            <span>{tr.capacity}</span>
            <input name="capacity" value={form.capacity} onChange={onChange} placeholder={tr.capacityPlaceholder} style={inputStyle} />
          </label>
          <label style={{ display: 'grid', gap: 6 }}>
            <span>{tr.power}</span>
            <input name="power" value={form.power} onChange={onChange} placeholder={tr.powerPlaceholder} style={inputStyle} />
          </label>
        </div>
        <label style={{ display: 'grid', gap: 6 }}>
          <span>{tr.description}</span>
          <textarea name="description" value={form.description} onChange={onChange} rows={4} style={{ ...inputStyle, resize: 'vertical' }} />
        </label>
        <label style={{ display: 'grid', gap: 8 }}>
          <span style={{ fontWeight: 700, fontSize: 15 }}>📸 {tr.photos}</span>
          <div style={{ 
            border: `2px dashed ${tokens.accent}`, 
            borderRadius: 12, 
            padding: '20px 16px', 
            background: tokens.surface,
            textAlign: 'center',
            cursor: 'pointer',
            transition: 'all 0.2s',
            position: 'relative'
          }}>
            <input 
              type="file" 
              multiple 
              onChange={onFile} 
              accept="image/*" 
              style={{
                position: 'absolute',
                inset: 0,
                opacity: 0,
                cursor: 'pointer',
                width: '100%',
                height: '100%'
              }} 
            />
            <div style={{ fontSize: 32, marginBottom: 8 }}>📷</div>
            <div style={{ fontWeight: 700, color: tokens.accent, marginBottom: 4, fontSize: 15 }}>{tr.clickUpload}</div>
            <div style={{ color: tokens.textMuted, fontSize: 13, marginBottom: 8 }}>{tr.dragDrop}</div>
            <div style={{ color: images.length > 0 ? tokens.accent : tokens.textMuted, fontSize: 14, fontWeight: 600 }}>
              {images.length > 0 ? `✓ ${images.length} ${images.length === 1 ? tr.photoSelected : tr.photosSelected}` : tr.noPhotos}
            </div>
          </div>
        </label>
        <div style={{ display: 'grid', gap: 8, border: `2px dashed ${tokens.border}`, borderRadius: 12, padding: 16, background: tokens.surface }}>
          <div style={{ fontWeight: 700, color: tokens.text, fontSize: 15, display: 'flex', alignItems: 'center', gap: 8 }}>
            <span>📄</span>
            <span>{tr.uploadTalon}</span>
          </div>
          <div style={{ color: tokens.textMuted, fontSize: 13, marginBottom: 4 }}>
            ⭐ {tr.detailedEval}
          </div>
          <div style={{ position: 'relative' }}>
            <input 
              type="file" 
              onChange={onTalonFile} 
              accept="image/*" 
              style={{
                position: 'absolute',
                inset: 0,
                opacity: 0,
                cursor: 'pointer',
                width: '100%',
                height: '100%'
              }}
            />
            <div style={{
              border: `1px solid ${tokens.border}`,
              borderRadius: 8,
              padding: '12px 16px',
              background: tokens.panel,
              textAlign: 'center',
              cursor: 'pointer',
              fontWeight: 600,
              color: talon ? tokens.accent : tokens.text
            }}>
              {talon ? `✓ ${talon.name}` : `📎 ${tr.selectTalon}`}
            </div>
          </div>
        </div>
        {error && <div style={{ color: '#ff5252' }}>{error}</div>}
        {success && <div style={{ color: tokens.accent }}>{success}</div>}
        <button disabled={submitting} type="submit" style={{ padding: '12px 16px', background: submitting ? tokens.border : tokens.accent, color: tokens.inverse, border: 'none', borderRadius: 8, fontWeight: 700, cursor: submitting ? 'not-allowed' : 'pointer' }}>
          {tr.submitRequest}
        </button>
      </form>
    </div>
  );
}

export default BuyBack;
